import { useState, type FormEvent } from 'react';
import { api } from '../lib/api';
import { APP_VERSION } from '../lib/version';

export function Signup() {
  const [schoolName, setSchoolName] = useState('');
  const [adminName, setAdminName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [phone, setPhone] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (password.length < 8) {
      setError('Password must be at least 8 characters');
      return;
    }

    setLoading(true);
    try {
      await api.signup({
        school_name: schoolName,
        admin_name: adminName,
        admin_email: email,
        admin_password: password,
        admin_phone: phone || undefined,
      });
      setSuccess(true);
    } catch (err: any) {
      setError(err.message || 'Registration failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="login-page">
        <div className="login-card">
          <div className="login-title-section">
            <h1 className="login-app-title">School Bus Tracker</h1>
          </div>
          <div style={{
            background: 'rgba(74, 222, 128, 0.1)',
            border: '1px solid rgba(74, 222, 128, 0.3)',
            borderRadius: '12px',
            padding: '24px',
            textAlign: 'center',
            margin: '0 0 24px 0',
          }}>
            <div style={{ fontSize: '48px', marginBottom: '12px' }}>&#9993;</div>
            <h2 style={{ color: '#4ade80', margin: '0 0 12px 0', fontSize: '20px' }}>Check Your Email!</h2>
            <p style={{ color: '#94a3b8', margin: '0 0 8px 0', fontSize: '14px' }}>
              We sent a verification link to
            </p>
            <p style={{ color: '#f1f5f9', fontWeight: 600, margin: '0 0 16px 0' }}>{email}</p>
            <p style={{ color: '#94a3b8', fontSize: '13px', margin: 0 }}>
              It expires in 24 hours. Check your spam folder if you don't see it.
            </p>
          </div>
          <div style={{ textAlign: 'center' }}>
            <a href="/" style={{ color: '#e94560', textDecoration: 'none', fontSize: '0.9rem' }}>
              Back to Login
            </a>
          </div>
          <div className="version-footer">{APP_VERSION}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-title-section">
          <h1 className="login-app-title">Register Your School</h1>
          <p className="login-tagline">Start tracking school buses in minutes. Free for 1 year.</p>
        </div>

        <form onSubmit={handleSubmit} aria-label="Registration form">
          <div className="form-group login-input-group">
            <span className="login-input-icon" style={{ fontSize: '14px' }}>&#127979;</span>
            <input
              type="text"
              value={schoolName}
              onChange={(e) => setSchoolName(e.target.value)}
              placeholder="School Name"
              required
              className="login-input"
              aria-label="School name"
            />
          </div>
          <div className="form-group login-input-group">
            <span className="login-input-icon" style={{ fontSize: '14px' }}>&#128100;</span>
            <input
              type="text"
              value={adminName}
              onChange={(e) => setAdminName(e.target.value)}
              placeholder="Your Name"
              required
              className="login-input"
              aria-label="Your name"
            />
          </div>
          <div className="form-group login-input-group">
            <span className="login-input-icon">@</span>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
              required
              autoComplete="email"
              className="login-input"
              aria-label="Email address"
            />
          </div>
          <div className="form-group login-input-group">
            <span className="login-input-icon">*</span>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password (min 8 characters)"
              required
              minLength={8}
              autoComplete="new-password"
              className="login-input"
              aria-label="Password"
            />
          </div>
          <div className="form-group login-input-group">
            <span className="login-input-icon">*</span>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Confirm Password"
              required
              minLength={8}
              autoComplete="new-password"
              className="login-input"
              aria-label="Confirm password"
            />
          </div>
          <div className="form-group login-input-group">
            <span className="login-input-icon" style={{ fontSize: '14px' }}>&#128222;</span>
            <input
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="Phone (optional)"
              className="login-input"
              aria-label="Phone number"
            />
          </div>

          {error && <div className="form-error">{error}</div>}

          <button type="submit" className="btn-login" disabled={loading}>
            {loading ? 'Creating Account...' : 'Create Free Account'}
          </button>
        </form>

        <div style={{ textAlign: 'center', margin: '1rem 0' }}>
          <a href="/" style={{ color: '#e94560', textDecoration: 'none', fontSize: '0.9rem' }}>
            Already have an account? Login
          </a>
        </div>

        <div className="version-footer">{APP_VERSION}</div>
      </div>
    </div>
  );
}
